module.exports = __webpack_public_path__ + "img/H15-5.1150aa3e.jpg";